import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Typography from '../../Typography';
import { FileState } from './FileState';
import { Filebox } from './styled';
const File = ({ error, fileName, isUploading, success = false, progress, handleReset, tryAnotherText }) => {
    const theme = useTheme();
    return (_jsxs(_Fragment, { children: [_jsxs(Filebox, { $error: !!error, children: [_jsx(Typography.TextMedium, { children: fileName }), _jsx(FileState, { error: error, isUploading: isUploading, onReset: handleReset, progress: progress, success: success, tryAnotherText: tryAnotherText })] }), error && _jsx(Typography.TextMedium, { color: theme.colors.critical100, children: error })] }));
};
export default File;
